import Vue from 'vue';
import App from './App';
import { router } from './router';
import Vconsole from 'vconsole';
import MyAduio from './components/audio/index.vue';

process.env.NODE_ENV === 'development' && new Vconsole()

const MyAudioConstructor = Vue.extend(MyAduio);
Vue.prototype.$myAudio = new MyAudioConstructor({
  el: document.createElement('div')
})

new Vue({
  router,
  el: '#app',
  render: h => h(App)
});
